import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
//Global Components
import KenCard from '../../../global_components/KenCard';
import KenTable from '../../../global_components/KenTable/kentable';
import KenInputField from '../../../global_components/KenInputField';
import KenGrid from '../../../global_components/KenGrid';
import KenDialogBox from '../../../global_components/KenDialogBox';
import KenButton from '../../../global_components/KenButton';
import KenLoader from '../../../Components/KenLoader/index';
import KenSelect from '../../../global_components/KenSelect';
// import KenPdfViewer from '../../../global_components/KenPdfViewer';
//Files
import '../FacultyManagement/style.scss';
import ContractData from './data.json';
import ChatSection from '../ContractManagement/chatHistory';
//Icons
import { BsChatDots } from 'react-icons/bs';
import { RiCheckFill } from 'react-icons/ri';
import { AiOutlineEye, AiOutlineUpload } from 'react-icons/ai';
//PDF and Document Viewer

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
  },
  headerRight: {
    display: 'flex',
    justifyContent: 'end',
  },
  headerBtn: {
    margin: '0 5px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  subMenu: {
    top: '28px !important',
    left: '38px !important',
  },
  addBtn: {
    marginTop: '22px',
  },
}));
let a = [];
const UserCell = (row, name, popOverOpen) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />{' '}
      {name}
    </p>
  );
};
const SubjectDocuments = () => {
  const history = useHistory();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [defaultSelectArray, setDefaultSelectArray] = useState([]);
  const [chatDialog, setChatDialog] = useState(false);
  const [viewDialog, setViewDialog] = useState(false);
  const [uploadDialog, setUploadDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [anchorSubmenu, setAnchorElSubmenu] = useState(null);
  const openSubmenu = Boolean(anchorSubmenu);
  const [subjectDocumentOptions, setSubjectDocumentOptions] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(
    'Session Delivery Plan'
  );
  const [docs, setDocs] = useState([]);
  const [errorFile, setErrorFile] = useState('');
  const [sendApprovalDialog, setSendApprovalDialog] = useState(false);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const handleSelectAllRows = (state) => {
    setSelectAllData(state);
  };
  const handleSelectRow = (evt, row, index) => {
    let uniqueArr = [];
    a.push({ title: row.name.props.children[2], year: 1997 });
    a.sort(dynamicSort('title'));
    for (let i = 0; i < a.length; i++) {
      let aw = a[i + 1] ? a[i + 1].title : '';
      if (a[i].title == aw) {
        i++;
      } else {
        uniqueArr.push(a[i]);
      }
    }
    console.log('uuuu', uniqueArr);
    setDefaultSelectArray(uniqueArr);
  };
  React.useEffect(() => {
    setLoading(true);
    const tableData = [];
    const data = ContractData['Subject Documents'];
    data.map((item) => {
      tableData.push({
        name: UserCell(item.img, item.name),
        phone: item.phone,
        email: item.email,
        association: item.association,
        subject: item.subjects,
        'Subject Documents': viewCell(item.view, item),
        'Approval Status': item.status,
        chat: chatCell(item.chat, item),
      });
    });
    const documentData = [];
    const docData = ContractData['Documents'];
    docData.map((item) => {
      documentData.push({
        label: item.label,
        value: item.value,
      });
    });
    setSubjectDocumentOptions(documentData);
    setData(tableData);
    setLoading(false);
  }, []);
  // Chat Dialog
  const chatCell = (rows, item) => {
    if (rows === true) {
      return (
        <BsChatDots size={16} onClick={() => openChatDialog(rows, item)} />
      );
    } else {
      return null;
    }
  };
  const openChatDialog = (rows, item) => {
    console.log('chat dialog', rows, item);
    setChatDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const chatDialogCancel = () => {
    setChatDialog(false);
  };
  const chatDialogSubmit = () => {
    setChatDialog(false);
  };
  // View Dialog
  const viewCell = (rows, item) => {
    if (rows === true) {
      return (
        <AiOutlineEye size={18} onClick={() => openViewDialog(rows, item)} />
      );
    } else {
      return null;
    }
  };
  const openViewDialog = (rows, item) => {
    console.log('chat dialog', rows, item);
    setViewDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const viewDialogCancel = () => {
    setViewDialog(false);
  };
  const viewDialogSubmit = () => {
    setViewDialog(false);
  };
  // Upload Dialog
  const uploadCell = (rows, item) => {
    if (rows === true) {
      return (
        <AiOutlineUpload
          size={18}
          onClick={() => openUploadDialog(rows, item)}
        />
      );
    } else {
      return null;
    }
  };
  const openUploadDialog = (rows, item) => {
    console.log('chat dialog', rows, item);
    setUploadDialog(true);
    let data = [];
    data.push(item);
    setSelectedRow(data);
  };
  const uploadDialogCancel = () => {
    setUploadDialog(false);
  };
  const uploadDialogSubmit = () => {
    setUploadDialog(false);
  };
  //Send Contact
  function handleSendApprovalDialog() {
    setAnchorElSubmenu(null);
    setSendApprovalDialog((prevState) => !prevState);
  }
  //handleDoc
  const handleSubjectDocument = (e) => {
    const docs2 = [];
    const docData = ContractData['Documents'];
    docData.forEach((item) => {
      if (item.label === e.target.value) {
        return docs2.push(item);
      }
    });
    let document = docs2[0]?.Doc;
    console.log('do', document);
    setDocs(document);
  };
  const fileValidation = (e) => {
    console.log('eee', e);
    const isRightFormat = filesFormats.includes(e.type);
    console.log('isRightFormat', isRightFormat);
    if (isRightFormat === false) {
      setErrorFile('Please Select Only Doc ,Pdf and Image');
    } else {
      setErrorFile('');
    }
  };
  const newArrayEmail = data.map((e) => {
    console.log('data------>', e.name.props.children[2]);
    return { title: e.name.props.children[2], year: 1997 };
    // { title: 'Jane Coper', year: 1994 },
  });
  const filesFormats = [
    '.doc',
    'image/jpeg',
    'image/jpg',
    'image/png',
    '.docx',
    'application/pdf',
  ];
  return (
    <Box>
      {loading && <KenLoader />}
      {/* Buttons */}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Grid container>
            <Grid item xs={6} className={classes.headerLeft}>
              <Typography variant="h6" className={classes.title}>
                Subject Documents
              </Typography>
            </Grid>
            <Grid item xs={6} className={classes.headerRight}>
              <Button
                variant="contained"
                color="primary"
                aria-controls={openSubmenu ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openSubmenu ? 'true' : undefined}
                onClick={handleSendApprovalDialog}
                className={classes.headerBtn}
                name="Send for Approval"
              >
                Send for Approval
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {/* Table */}
      <Box className="cardlsitbox">
        <KenCard elevation={0}>
          {data.length > 0 ? (
            <div className="contract-mgmt-table">
              <KenTable
                data={data}
                rowClick={(item) => {
                  return null;
                }}
                allcheckboxData={(state) => handleSelectAllRows(state)}
                onRowCheckBox={(event, row, index) =>
                  handleSelectRow(event, row, index)
                }
              />
            </div>
          ) : null}
        </KenCard>
      </Box>
      {/* Chat Box */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Chat History
            </Typography>
          }
          open={chatDialog}
          icon={<RiCheckFill />}
          handleClose={() => chatDialogCancel()}
          negativeButtonClick={() => chatDialogCancel()}
          positiveButtonClick={() => chatDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          <ChatSection data={selectedRow} />
        </KenDialogBox>
      </div>
      {/* Subject Document View */}
      <div className="faculty-mgmt-div">
        <KenDialogBox
          title={
            <Typography variant="h6" className={classes.dialogHeader}>
              Subject Documents
            </Typography>
          }
          open={viewDialog}
          icon={<RiCheckFill />}
          handleClose={() => viewDialogCancel()}
          negativeButtonClick={() => viewDialogCancel()}
          positiveButtonClick={() => viewDialogSubmit()}
          positiveButtonText="Ok"
          negativeButtonText="Cancel"
          style={{ width: '80%' }}
          dividers
        >
          {/* Docs Body */}
          <Grid container xs={12}>
            <KenSelect
              options={subjectDocumentOptions}
              value={selectedDocument}
              dropdownColor="#FFFFFF"
              onChange={handleSubjectDocument}
              label="Select Document to View"
              required
            />
          </Grid>
          <Grid container xs={12}>
            <Button
              variant="contained"
              color="primary"
              aria-controls={openSubmenu ? 'demo-customized-menu' : undefined}
              aria-haspopup="true"
              // aria-expanded={openSubmenu ? 'true' : undefined}
              // onClick={handleSendApprovalDialog}
              className={classes.headerBtn}
              name="Import PDF"
              style={{margin: "10px 10px 0px 0px"}}
            >
              Import PDF
            </Button>
            {/* <KenPdfViewer pdfFileUrl={docs} /> */}
          </Grid>
        </KenDialogBox>
      </div>
      {/* Send for Approval */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send for Approval
          </Typography>
        }
        open={sendApprovalDialog}
        handleClose={() => handleSendApprovalDialog()}
        negativeButtonClick={() => handleSendApprovalDialog()}
        positiveButtonClick={() => handleSendApprovalDialog()}
        positiveButtonText="Send"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              multiple
              id="size-small-outlined"
              size="large"
              options={newArrayEmail}
              getOptionLabel={(option) => option.title}
              defaultValue={defaultSelectArray}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  placeholder="Enter faculty name"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField label="Subject" required />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              id="outlined-email-input"
              label="Body"
              multiline
              rows="10"
              className={classes.textField}
              type="text"
              name="subject"
              // autoComplete="email"
              margin="normal"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <KenInputField
              label="Attachment"
              type="file"
              onChange={(e) => fileValidation(e.target.files[0])}
              required
            />
            <p style={{ color: 'red' }}>{errorFile}</p>
          </Grid>
        </Grid>
      </KenDialogBox>
    </Box>
  );
};
export default SubjectDocuments;
